<template>
  <page-header-wrapper>
    <!-- 搜索框 -->
    <a-card :bordered="false">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入搜索分类标题"
              enter-button
              allow-clear
              @search="getLists()"
            />
          </div>
        </standard-form-row>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false" title="分类列表">
      <div slot="extra">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-form
        :form="form"
        layout="inline"
        v-action:add
        style="margin-bottom:15px;background:#f0f2f5;padding:15px"
      >
        <a-form-item label="分类名称">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入分类名称' },
                  { max: 10, message: '分类名称不能超过十个字符' }
                ]
              }
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="排序">
          <a-input
            name="sort"
            v-decorator="[
              'sort',
              {
                initialValue: '0'
              }
            ]"
          />
        </a-form-item> -->
        <a-form-item>
          <a-button type="primary" @click="handleSubmitForm" icon="plus">
            添加
          </a-button>
        </a-form-item>
      </a-form>

      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
      >
        <template v-for="col in ['name']" :slot="col" slot-scope="text, record, index, expanded">
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.id, expanded)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot="state" slot-scope="text, record">
          <a-switch
            v-action:state
            default-checked
            :checked="record.state === 1"
            @change="value => handleChangeState(value, record.id)"
          >
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => handleSave(record.id)"><a-icon type="check" /> 保存</a>
              <a @click="() => handleCancel(record.id)"><a-icon type="close" /> 取消</a>
            </span>
            <span v-else>
              <a @click="() => handleEdit(record.id)" v-action:update><a-icon type="edit" /> 编辑</a>
            </span>
            <a-divider type="vertical" v-action:update />
            <a-popconfirm
              v-if="list.length"
              title="确定要删除吗？"
              okText="确定"
              cancelText="取消"
              @confirm="() => handleOnDelete(record.id)"
              v-action:delete
            >
              <a href="javascript:;"><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, category } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow } from '@/components'
const apiList = {
    getList: '/info/categories',
    create: '/info/categories/create',
    update: '/info/categories/',
    delete: '/info/categories/'
}
const fields = ['title', 'sort', 'state', 'created_at']
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '分类名称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
    },
    // {
    //     title: '排序',
    //     dataIndex: 'sort',
    //     sorter: true,
    //      scopedSlots: { customRender: 'sort' }
    //  },
    {
        title: '创建时间',
        sorter: true,
        dataIndex: 'created_at'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'informationCategory',
    mixins: [list, table, category], // 使用mixins
    components: {
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            fields,
            apiList,
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取分类列表
    },
    methods: {

    }
}
</script>
